/**
 * @license
 *
 * Copyright IBM Corp. 2021
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Dual themes
 */
export enum DUAL_THEMES {
  /**
   * White and Gray 10
   */
  WHITE_AND_G10 = 'white-and-g10',

  /**
   * Gray 10 and White
   */
  G10_AND_WHITE = 'g10-and-white',

  /**
   * Gray 90 and Gray 100
   */
  G90_AND_G100 = 'g90-and-g100',

  /**
   * Gray 10 and White
   */
  G100_AND_G90 = 'g100-and-g90',

  /**
   * Default theme
   */
  MONOTHEME = '',
}

/**
 * Adjacent themes
 */
export enum ADJACENT_THEMES {
  /**
   * Default theme
   */
  MONOTHEME = '',

  /**
   * Dual theme
   */
  DUAL_THEME = 'dual-theme',
}
